import type { VerifyAccountStore } from '../domain/verifyAccountTypes'
import { useStore } from 'zustand'
import { useVerifyAccountDependencies } from './verifyAccountDependencies'

export function useVerifyAccountStore<T>(selector: (state: VerifyAccountStore) => T): T {
  const { store } = useVerifyAccountDependencies()
  return useStore(store, selector)
}
